import React, { Component, Fragment, lazy, Suspense } from 'react';
import { Redirect } from "react-router-dom";
import config from './../../../config/config.json';
import { IconButton, Grid, Collapse, Button, Icon, Card, CardContent, Typography } from '@material-ui/core';
import DashboardCard from './DashboardCard';
import { Alert, AlertTitle } from '@material-ui/lab';
import CloseIcon from '@material-ui/icons/Close';
import { enabledPermissions } from '../../../services/enabledPermissions';
import { connect } from "react-redux";

const ConfiguracionModal = lazy(() => import("./sections/partials/ConfiguracionModal"));

class Dashboard extends Component {
	constructor(props) {
		super(props);

		this.state = {
			open: true,
			userData: {},
			cards: [],
			loginStatus: false,
			passwordResetStatus: null,
			responseLogin: '',
			openAlert: true,
			visibilityCards: [],
			openConfigModal: false,
			dashboardLoaded: false
		}
	}

	handleLogout = () => {
		this.props.getLogout(window.localStorage.getItem('headersSetCookie'));
	}

	componentDidMount = async () => {
		if (this.props.location.state === undefined) {
			this.setState({ loginStatus: false });
		} else {
			this.setState({ loginStatus: true, cards: config.cards });
		}
	}

	handleConfiguracion = async () => {
		this.setState({ openConfigModal: true })
	};

	componentDidUpdate(prevProps, prevState, snapshot) {
		//Recibe los cambios de valores del store correspondiente al usuario y lo almacena en el local storage.
		if (prevProps.responseUserLogin !== this.props.responseUserLogin) {
			if (window.localStorage.getItem('userData') !== null) {
				let permissionsItems = JSON.parse(window.localStorage.getItem('userData')).modules;
				let visibilityItems = JSON.parse(window.localStorage.getItem('userData')).dashboard_module;
				this.setState({ cards: enabledPermissions(config.cards, permissionsItems), visibilityCards: visibilityItems, dashboardLoaded: true })
			}
		}

		//Recibe los cambios del store correspondientes a la solicitud de cambio de contraseña.
		if ((prevProps.responsePasswordReset != this.props.responsePasswordReset)
			|| (prevProps.responseError != this.props.responseError && this.props.errorPassword)) {
			if (this.props.responsePasswordReset.status != undefined && this.props.responsePasswordReset.status == 'OK') {   // no hubo errores
				this.handleLogout();
				this.setState({ passwordResetStatus: this.props.responsePasswordReset.status });
			} else { // hubo errores
				this.setState({ passwordResetStatus: 'FAILED' })
			}
		}
	}

	collapseAlert = () => {
		this.setState({ openAlert: false });
	}

	handleCloseModalConfiguracion = () => {
		this.setState({ openConfigModal: false })
	};

	render() {
		const visibleCards = this.state.cards.filter(card => {
			const orderInfo = this.state.visibilityCards?.find(orderCard => orderCard.module === card.permissionName);
			return orderInfo && orderInfo.visibility; // Corregí la comparación de visibilidad
		});
		return (
			this.state.passwordResetStatus == "OK"	// Si recibe una respuesta con status OK autorizando cambio de contraseña.
				? <Redirect to={{ pathname: `/login`, state: { resetPassword: true } }} />
				: (window.localStorage.getItem('headersSetCookie') == undefined // Si no tiene info del usuario en localStorage
					? (<Redirect to={"/login"} exact />) 					  // Redirecciona al login
					: (<Fragment>
						{this.state.responseLogin !== "" && (
							<Collapse in={this.state.openAlert}>
								<Alert severity="info" className="mb-2"
									action={
										<IconButton
											aria-label="close"
											color="inherit"
											size="small"
											onClick={() => {
												this.collapseAlert(false);
											}}
										>
											<CloseIcon fontSize="inherit" />
										</IconButton>
									}
								>
									{this.state.responseLogin}
								</Alert>
							</Collapse>
						)}

						{this.state.passwordResetStatus == "FAILED" && (
							<Collapse in={this.state.open}>
								<Grid container spacing={1}>
									<Grid item sm={12}>
										<Alert severity="warning"
											action={
												<IconButton
													aria-label="close"
													color="inherit"
													size="small"
													onClick={this.collapseAlert}
												>
													<CloseIcon fontSize="inherit" />
												</IconButton>
											}
										>
											No podemos autorizar su cambio de contraseña. Verifique que tenga los permisos necesarios y/o intentelo nuevamente.
										</Alert>
										<br />
									</Grid>
								</Grid>
								{/* </Container> */}
							</Collapse>
						)}

						{visibleCards.length !== 0 && (
							<Grid container spacing={3}>
								{visibleCards.sort((a, b) => a.name.localeCompare(b.name)).map((card, i) => (
									<DashboardCard key={i} indice={i} card={card} />
								))}
							</Grid>
						)} 
						{visibleCards.length === 0 && this.state.dashboardLoaded && (
							<Card className="card-box">
								<CardContent className="Detail_Action_ViewContainer">
									<>
										<div className='conciliationCreateMessage'>
											<div><Typography>¡Hola! Parece que tu dashboard está vacío y sin personalizar. Haz clic en 'Configuración' para adaptarlo según tus necesidades.</Typography></div>
											<Button
												onClick={this.handleConfiguracion}
												variant="outlined"
												color='primary'
												startIcon={<Icon>settings</Icon>}
												style={{ marginBottom: 15 }}
											>
												Configuración
											</Button>
										</div>

									</>
								</CardContent>
							</Card>
						)}
						<Suspense fallback={<div>Loading...</div>}>
							{this.state.dashboardLoaded &&
								<ConfiguracionModal
									openModalConfiguracion={this.state.openConfigModal}
									handleCloseModalConfiguracion={this.handleCloseModalConfiguracion}
									itemsDashboard={this.state.cards}
								/>
							}
						</Suspense>
					</Fragment>
					)
				)
		)
	}
}

const mapStateToProps = reducers => {
	return reducers.loginReducer;
};
const mapDispachToProps = dispatch => {
	return {
		getLogout: (access) => dispatch({ type: "GET_LOGOUT", access }),
	};
};

export default connect(mapStateToProps, mapDispachToProps)(Dashboard);